module.exports = __webpack_public_path__ + "static/media/18.c40b8910.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/18.jpg
// module id = 949
// module chunks = 0